module.exports = __webpack_public_path__ + "img/symbol_8.a2f74bb0.png";